import React from 'react';

import { ToggleButton } from '@mui/material';

import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';

const ButtonSidebarForm = createBlockInputSection({
  title: 'Button block',
  inputs: [
    { type: 'text', props: { label: 'Text', name: 'text', autofocus: true, autohighlight: true } },
    { type: 'text', props: { label: 'URL', name: 'url' } },
    {
      type: 'toolbar-toggle',
      props: {
        label: 'Width',
        name: 'fullWidth',
        children: [
          <ToggleButton key={1} value={true}>
            Full
          </ToggleButton>,
          <ToggleButton key={2} value={false}>
            Auto
          </ToggleButton>,
        ],
      },
    },
    {
      type: 'toolbar-toggle',
      props: {
        label: 'Size',
        name: 'size',
        children: [
          <ToggleButton key={1} value="x-small">
            Xs
          </ToggleButton>,
          <ToggleButton key={2} value="small">
            Sm
          </ToggleButton>,
          <ToggleButton key={3} value="medium">
            Md
          </ToggleButton>,
          <ToggleButton key={4} value="large">
            Lg
          </ToggleButton>,
        ],
      },
    },
    {
      type: 'toolbar-toggle',
      props: {
        label: 'Style',
        name: 'buttonStyle',
        children: [
          <ToggleButton key={1} value="rectangle">
            Rectangle
          </ToggleButton>,
          <ToggleButton key={2} value="rounded">
            Rounded
          </ToggleButton>,
          <ToggleButton key={3} value="pill">
            Pill
          </ToggleButton>,
        ],
      },
    },

    { type: 'color', props: { label: 'Text color', name: 'buttonTextColor' } },
    { type: 'color', props: { label: 'Button color', name: 'buttonBackgroundColor' } },
    'backgroundColor',
    'fontFamily',
    'fontSize',
    'fontWeight',
    'textAlign',
    'padding',
    HideSectionInput,
  ],
});

export default ButtonSidebarForm;
